import { get1MM, mm2px } from "@/utils/size"
import { LineJumpType } from "./services/modal"

export const PortConfig = {
  LineColor: '#31d0c6',
  ActiveLineColor: '#0170fe',
  CircleRadius: 5
}

export enum PortTypes {
  NozzlePort = 'NozzlePort',
  SvgNozzlePort = 'SvgNozzle',
  LineJumpPort = 'LineJumpPort',
  LinePort = 'LinePort'
}

export enum EdgeSides {
  Source,
  Target
}

export enum LineType {
  FlowLine,
  Template,
  Line,
}

export const PapersizeOptions = [
  { label: 'A4', value: 'A4', width: mm2px(297), height: mm2px(210) },
  { label: 'A3', value: 'A3', width: mm2px(420), height: mm2px(297) },
];

export enum DrawingMode {
  None,
  Line,
  Stream
}

export const LineJumps = {
  [LineJumpType.Circle]: {
    svg: `
      <svg width="2.5mm" height="2.5mm" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg" style="overflow: visible">
        <path d="M0 12.5 A 12.5 12.5 0 0 1 25 12.5"
          style="fill:none;stroke:black;stroke-width:0.4mm;stroke-linejoin:round;vector-effect: non-scaling-stroke;" />
      </svg>
    `,
    start: {x: 0, y: 0.5},
    end: {x: 1, y: 0.5},
    size: {width: mm2px(2.5), height: mm2px(2.5)}
  },
  [LineJumpType.Blank]: {
    svg: `
      <svg width="2.5mm" height="2.5mm" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg" style="overflow: visible">
      </svg>
    `,
    start: {x: 0, y: 0.5},
    end: {x: 1, y: 0.5},
    size: {width: mm2px(2.5), height: mm2px(2.5)}
  },
  [LineJumpType.Wave]: {
    svg: `
      <svg width="2.5mm" height="2.5mm" xmlns="http://www.w3.org/2000/svg" overflow="visible">
          <svg width="1.25mm" height="100%" viewBox="0 0 12.5 25" overflow="visible" preserveAspectRatio="none">
            <path d="M 0 0 Q 6.25,6.25 0,12.5 T 0,25" style="fill:none;stroke:black;stroke-width:0.4mm;stroke-linejoin:round;stroke-linecap:round;vector-effect: non-scaling-stroke;"/>
          </svg>
          <svg x="100%" width="1.25mm" height="100%" viewBox="0 0 12.5 25" overflow="visible" preserveAspectRatio="none">
            <path d="M 0 0 Q 6.25,6.25 0,12.5 T 0,25" style="fill:none;stroke:black;stroke-width:0.4mm;stroke-linejoin:round;stroke-linecap:round;vector-effect: non-scaling-stroke;"/>
          </svg>
      </svg>
    `,
    start: {x: 0, y: 0.5},
    end: {x: 1, y: 0.5},
    size: {width: mm2px(2.5), height: mm2px(2.5)}
  }
}